import { Box, useStyleConfig, useColorModeValue } from "@chakra-ui/react";
function Card(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box
      __css={styles}
      p="20px"
      bg={useColorModeValue("white", "gray.700")}
      borderRadius="20px"
      boxShadow="sm"
      {...rest}
    >
      {children}
    </Box>
  );
}

export default Card;
